import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SidebarComponent from '../common/sidebar-component';
import KeywordResultsContext from './context';
import SidebarContributorsComponentHeader from '../common/sidebar/sidebar-contributors-component-header';
import useGetContributorsByKeywords from '../../../services/contributors/by-keywords-service';
import NanoProfile from '../common/nano-profile';

const ContributorsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-top: 20px;
`;

export default function TopContributors({ keyword }) {
  const { dispatch } = React.useContext(KeywordResultsContext);
  const [{ data }, executeQuery] = useGetContributorsByKeywords([keyword.slug], 3);

  React.useEffect(() => {
    executeQuery();
  }, [executeQuery]);

  React.useEffect(() => {
    if (_.get(data, 'contributors.length')) {
      dispatch({ type: 'setContributors', payload: data.contributors });
    }
  }, [data, dispatch]);

  if (!_.get(data, 'contributors.length')) {
    return null;
  }

  return (
    <SidebarComponent>
      <SidebarContributorsComponentHeader
        query={keyword.value}
      />
      <ContributorsContainer>
        {data.contributors.map(p => (
          <NanoProfile key={`contributor-${p.id}`} profile={p} dark small />
        ))}
      </ContributorsContainer>
    </SidebarComponent>
  );
}

TopContributors.propTypes = {
  keyword: PropTypes.shape({
    value: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
};
